export const downloadFile = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

export function parseFileNameFromContentDisposition(contentDisposition?: string | null): string {
  const fallbackFileName = 'download.xlsx';
  if (!contentDisposition || !contentDisposition.toLowerCase().includes('filename=')) {
    return fallbackFileName;
  }

  let fileNamePart = contentDisposition.split('filename=')[1]?.split(';')[0]?.trim();

  return fileNamePart || fallbackFileName;
}
